import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ContainerScrollModule } from '@app/components/container-scroll/container-scroll.module';
import { DialogModule } from '@app/components/dialog/dialog.module';
import { IconsModule } from '@app/components/icons/icons.module';
import { SharedModule } from '@app/shared/shared.module';

import { DialogWishlistItemComponent } from './dialog-wishlist-item/dialog-wishlist-item.component';
import { WishlistRoutingModule } from './wishlist-routing.module';
import { WishlistComponent } from './wishlist.component';

@NgModule({
  declarations: [
    WishlistComponent,
    DialogWishlistItemComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    WishlistRoutingModule,
    ContainerScrollModule,
    DialogModule,
    IconsModule
  ],
  entryComponents: [
    DialogWishlistItemComponent
  ]
})
export class WishlistModule { }
